import { render } from "./main-footer.vue?vue&type=template&id=b7491386&scoped=true&ts=true"
import script from "./main-footer.vue?vue&type=script&lang=ts"
export * from "./main-footer.vue?vue&type=script&lang=ts"

import "./main-footer.vue?vue&type=style&index=0&id=b7491386&lang=scss"
import "./main-footer.vue?vue&type=style&index=1&id=b7491386&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7491386"]])

export default __exports__